/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  ConstructionScheduleRestService,
  MaintenanceScheduleRestService,
  PreConstructionScheduleRestService,
  SalesScheduleRestService,
  ScheduleType,
} from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { SlicedDataSource } from '@gh/core-data';
import { ScheduleFinderListItem } from './schedule-finder.model';

export interface ScheduleFinderDialogConfig extends FinderDialogConfig {
  type: ScheduleType;
}

export const DATE_FILTER = [
  { name: 'lbl_all', value: 'ALL'},
  { name: 'lbl_no_date', value: 'NO_DATE'},
  { name: 'lbl_date_set', value: 'DATE_SET'},
];

@Injectable()
export class ScheduleFinderBusinessService {
  constructor(private constructionScheduleRest: ConstructionScheduleRestService,
              private preConstructionScheduleRest: PreConstructionScheduleRestService,
              private maintenanceScheduleRest: MaintenanceScheduleRestService,
              private salesScheduleRest: SalesScheduleRestService) {
  }

  findAllAsDataSource(type: ScheduleType, searchString: string): SlicedDataSource<ScheduleFinderListItem> {
    switch (type) {
      case ScheduleType.Construction:
        return this.constructionScheduleRest.findAllAsFinderDataSource({
                                                                         searchString,
                                                                         showActive: true,
                                                                         showFinalized: true,
                                                                         handoverDate: 'ALL',
                                                                         showCompleted: false,
                                                                         showMyJobs: false,
        });
      case ScheduleType.PreConstruction:
        return this.preConstructionScheduleRest.findAllAsFinderDataSource({
                                                                            searchString,
                                                                            authToCommenceDate: 'ALL',
                                                                            showActive: true,
                                                                            showFinalized: true,
                                                                            showCompleted: false,
                                                                            showNotProceeding: true,
                                                                            showMyJobs: false,
                                                                          });
      case ScheduleType.Maintenance:
        return this.maintenanceScheduleRest.findAllAsFinderDataSource({
                                                                        searchString,
                                                                        showActive: true,
                                                                        showFinalized: true,
                                                                        showCompleted: false,
                                                                        handoverDate: 'ALL',
                                                                        completedDate: 'ALL',
                                                                        showMyJobs: false,
        });
      case ScheduleType.Sales:
        return this.salesScheduleRest.findAllAsFinderDataSource({
                                                                  searchString,
                                                                  showActive: true,
                                                                  showCompleted: false,
                                                                  showWillNotCompleted: true,
        });
      default:
        throw new Error(`ScheduleFinderBusinessService: unknown type of schedule: ${type}`);
    }
  }
}
